import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ComponentMessageDispatcher {
  constructor() {}

  private _subject = new BehaviorSubject<any>(null);

  messages = this._subject.asObservable().pipe(filter(next => next != null));

  messageDelivered() {
    this._subject.next(null);
  }

  send(message: any) {
    this._subject.next(message);
  }
}
